import { CalendarToolbar } from "./CalendarToolbar.js";
import { addMonths, addWeeks, monthGridDays, rangeLabel, weekDays } from "./utils/date-grid.js";
import { MonthGrid } from "./MonthGrid.js";
import { WeekGrid } from "./WeekGrid.js";
import "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/Calendar/Calendar.tsx
function Calendar(props) {
	const days = props.view === "week" ? weekDays(props.anchorMs, props.timeZone) : monthGridDays(props.anchorMs, props.timeZone);
	return /* @__PURE__ */ jsxs("div", {
		className: "gap-sm flex flex-col",
		children: [/* @__PURE__ */ jsx(CalendarToolbar, {
			onNext: () => props.onAnchorChange(props.view === "week" ? addWeeks(props.anchorMs, 1, props.timeZone) : addMonths(props.anchorMs, 1, props.timeZone)),
			onPrev: () => props.onAnchorChange(props.view === "week" ? addWeeks(props.anchorMs, -1, props.timeZone) : addMonths(props.anchorMs, -1, props.timeZone)),
			onToday: () => props.onAnchorChange(Date.now()),
			onViewChange: props.onViewChange,
			rangeLabel: rangeLabel(props.anchorMs, props.view, props.timeZone),
			view: props.view
		}), props.view === "week" ? /* @__PURE__ */ jsx(WeekGrid, {
			days,
			events: props.events,
			onDayClick: props.onDayClick,
			onEventClick: props.onEventClick,
			renderEventContent: props.renderEventContent,
			renderEventDetail: props.renderEventDetail,
			timeZone: props.timeZone
		}) : /* @__PURE__ */ jsx(MonthGrid, {
			anchorMs: props.anchorMs,
			dayClassName: props.dayClassName,
			days,
			events: props.events,
			onDayClick: props.onDayClick,
			onEventClick: props.onEventClick,
			renderDayContent: props.renderDayContent,
			renderEventContent: props.renderEventContent,
			renderEventDetail: props.renderEventDetail,
			timeZone: props.timeZone
		})]
	});
}
//#endregion
export { Calendar };

//# sourceMappingURL=Calendar.js.map